import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ESignature from '../contract/ESignature';
import ContractSelectorModal from './ContractSelectorModal';

const SourcingESignature = () => {
  const navigate = useNavigate();
  const [showSelector, setShowSelector] = useState(false);

  const handleNewDocument = () => {
    setShowSelector(true);
  };

  const handleContractSelect = (contract) => {
    // Pass both the human-readable contractId (CT-XXXX) and the Mongo _id
    const contractId = contract.id || contract.contractId || String(contract._id);
    const contractMongoId = contract._id ? String(contract._id) : contractId;
    navigate(
      `/sourcing/e-signature/edit/new?contractId=${encodeURIComponent(contractId)}&contractMongoId=${encodeURIComponent(contractMongoId)}`
    );
    setShowSelector(false);
  };

  return (
    <>
      <ESignature module="rfp" onNewDocument={handleNewDocument} />
      {showSelector && (
        <ContractSelectorModal
          onSelect={handleContractSelect}
          onClose={() => setShowSelector(false)}
        />
      )}
    </>
  );
};

export default SourcingESignature;
